import React from 'react';
import PropTypes from 'prop-types';
import { track } from '@bnnvara/analytics/src/track';
import * as S from './styled';

const HubLogo = ({ data }) => {
  const { name, logoUrl, slug, __typename } = data;

  if (!logoUrl) return null;

  return (
    <S.Circle
      href={`/${slug}`}
      onClick={() => {
        track('page', 'click', `${__typename.toLowerCase()}-hub-${name}`);
      }}
      aria-label={`Link naar de home van ${name}`}
    >
      <S.BrandImage src={logoUrl} alt={`Logo ${name}`} />
    </S.Circle>
  );
};
HubLogo.defaultProps = {
  data: {
    logoUrl: null,
  },
};
HubLogo.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    slug: PropTypes.string.isRequired,
    __typename: PropTypes.string.isRequired,
  }),
};

export default HubLogo;
